module.exports = __webpack_public_path__ + "img/radio-box-inactive.07618fba.svg";